import Structure from './Structure'
import { MainMenuOption } from './MainMenu'
import OrganizationMenu from './OrganizationMenu'
import AdminMenu from './AdminMenu'

interface SubMenuProps {
    selectedOption: MainMenuOption
}
export default function SubMenu({ selectedOption }: SubMenuProps) {
    switch (selectedOption) {
        case 'organization':
            return <OrganizationMenu />

        case 'structure':
            return <Structure />

        case 'admin':
            return <AdminMenu />

        default:
            return ''
    }
}
